import {API_URL} from "../config";

export const GET_ZONES_URL = `${API_URL}/zones`;
export const GET_SUBZONES_URL = `${API_URL}/subzone`;
export const GET_AVAILABLE_TIMES_URL = `${API_URL}/checkavailabletime`;
export const SCHEDULER_INSTALLATION_URL = `${API_URL}/installation`;
export const LOGIN_URL = `${API_URL}/employeelogin`;
export const CHECK_AVAILABLE_DATES_URL = `${API_URL}/checkavailabledate`;

